import React from 'react';
import { PageHeader, Tabs, Spin } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Notification',
    breadcrumbName: 'Notification',
  },
];
const Notification = () => {
  return (
    <>
      <PageHeader title="Notification-default" breadcrumb={{ routes }} subTitle="Notification" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="notification_wrapper">
          <div className="content_wrap">
            <div className="contents_item">
              <div className="content_first">
                <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
                  <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
                </svg>
              </div>
              <div className="content_last">
                <div className="title">Mania Framework</div>
                <div className="content_detail">
                  동해물과 백두산이 마르고 닳도록 하느님이 보우하사 우리나라만세<br /> 무궁화 삼천리 화려강산 대한사람 대한으로 길이 보전하세
                </div>
                <a className="btn btn_sm">버튼</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<<div className="notification_wrapper">
  <div className="content_wrap">
    <div className="contents_item">
      <div className="content_first">
        <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
          <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
        </svg>
      </div>
      <div className="content_last">
        <div className="title">Title</div>
        <div className="content_detail">
          Content
        </div>
        <a className="btn btn_sm">버튼</div>
      </div>
    </div>
  </div>
  </div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>





      <PageHeader title="Notification-colums" subTitle="Notification" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="notification_wrapper colums">
          <div className="content_wrap">
            <div className="contents_item">
              <div className="content_first">
                <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
                  <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
                </svg>
              </div>
              <div className="content_last">
                <div className="title">Mania Framework</div>
                <div className="content_detail">동해물과 백두산이 마르고 닳도록</div>
                <div className="btn btn_sm">버튼</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div className="notification_wrapper colums">
  <div className="content_wrap">
    <div className="contents_item">
      <div className="content_first">
        <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
          <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
        </svg>
      </div>
      <div className="content_last">
        <div className="title">Title</div>
        <div className="content_detail">Content</div>
        <div className="btn btn_sm">버튼</div>
      </div>
    </div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


      <PageHeader title="Notification-colums-3" subTitle="Notification" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="notification_wrapper colums">
          <div className="content_wrap">
            <div className="contents_item">
              <div className="content_first">
                <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
                  <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
                </svg>
              </div>
              <div className="content_last">
                <div className="title">Mania Framework</div>
                <div className="content_detail">동해물과 백두산이 마르고 닳도록</div>
                <div className="btn btn_sm">버튼</div>
              </div>
            </div>
            <div className="contents_item">
              <div className="content_first">
                <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
                  <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
                </svg>
              </div>
              <div className="content_last">
                <div className="title">Mania Framework</div>
                <div className="content_detail">동해물과 백두산이 마르고 닳도록</div>
                <div className="btn btn_sm">버튼</div>
              </div>
            </div>
            <div className="contents_item">
              <div className="content_first">
                <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
                  <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
                </svg>
              </div>
              <div className="content_last">
                <div className="title">Mania Framework</div>
                <div className="content_detail">동해물과 백두산이 마르고 닳도록</div>
                <div className="btn btn_sm">버튼</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div className="notification_wrapper colums">
  <div className="content_wrap">
    <div className="contents_item">
      <div className="content_first">
        <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
          <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
        </svg>
      </div>
      <div className="content_last">
        <div className="title">Title</div>
        <div className="content_detail">Content</div>
        <div className="btn btn_sm">버튼</div>
      </div>
    </div>
  </div>
    <div className="contents_item">
      <div className="content_first">
        <svg width="100px" height="100px" className="circle" viewBox="0 0 300 300">
          <path className="spinner" d="M 150, 150 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"/>
        </svg>
      </div>
      <div className="content_last">
        <div className="title">Title</div>
        <div className="content_detail">Content</div>
        <div className="btn btn_sm">버튼</div>
      </div>
    </div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default Notification;
